import { geocoderDefaultState } from '../geocoder';
import { defaultInteraction, defaultMapView } from '../map/functions';
import { AppConfig, MessageRecordLang } from '../source';
import { checkURLScheme } from '../util';

export const defaultShape = (config: AppConfig) => ({
    'app/force-refresh': 0,
    'app/user': config.user,
    'app/api-root': checkURLScheme(config.api),
    'app/csrf': config.csrf,
    'app/root': checkURLScheme(config.root),
    'app/apps': config.apps,
    'app/urls': config.urls,
    'app/fonts': {
        picto: {
            url: config.fonts.picto,
            loaded: false,
        },
        label: {
            url: config.fonts.label,
            loaded: false,
        },
    },
    'app/copied-text': null,
    'app/route': config.args,
    'app/admin-query': config.admin_query,
    'app/lang': 'fr' as MessageRecordLang,
    'app/languages': config.languages,
    'app/activityToken': null,
    'app/appselect/visible': false,
    'app/focus-id': null,
    'app/collapsible': {},
    'app/geocoder': geocoderDefaultState,
    'app/geocoder/input': '',
    'app/select/open/id': null,
    'app/maintenance': config.maintenance,
    'app/messages': config.app_messages,
    'app/data-crs': config.dataCrs,
    'app/map-crs': config.mapCrs,
    'app/default-extent': config.defaultExtent,
    'app/angled': config.angled,

    'data/alias': [],
    'data/component/edited': {},
    'sdi/component/info/modal/status': {},
    'data/terms': [],
    'data/domains': [],
    'data/highlighted-baselayers': config.highlighted_baselayers,

    'form/data/geo-ref': {},
    'form/input/geo/question': null,
    'form/component/button': {},
    // port/map/* are set in most clients
    // robin added these keys here while factoring the forms in sdi
    // => would it be useful / stupid to gather those keys here ?
    'form/port/map/interaction': defaultInteraction(),
    'form/port/map/view': defaultMapView(config),
    'form/ref/geo/loading': [],
    'form/referentials': [],
    'form/filteredAvailableReferentials': [],
});
